<template>
  <li
    v-if="isAccessible"
    @mouseover="toggleMenu(false)"
    ref="itemLeftMenu"
    :class="{ 'navigationmain-item' : step === 0, 'is-active': isActive }">
    <router-link
      v-if="step === 0 && link.routeName"
      :id="'menuLeftLayout' + link.routeName"
      :to="routeWithParam"
      :key="link.routeName">
      <span
        v-if="link.text"
        @click="toggleMenu">
        <span
          v-if="link.badge === 'options' && runningOptions.length"
          class="is-inline-flex badge has-badge-notification has-badge-rounded"
          :data-badge="runningOptions.length">
          <i
            v-if="link.iconClasses"
            :class="link.iconClasses"></i>
        </span>
        <span
          v-else-if="link.badge === 'denunciation' && runningDenunciations.length"
          class="is-inline-flex badge has-badge-notification has-badge-rounded"
          :data-badge="runningDenunciations.length">
          <i
            v-if="link.iconClasses"
            :class="link.iconClasses"></i>
        </span>
        <i
          v-else-if="link.iconClasses"
          :class="link.iconClasses"></i>
        <p
          :class="{'nav-label': link.iconClasses}"
          class="is-size-6 is-padding-top-xxsmall">{{ link.text }}</p>
      </span>
    </router-link>

    <p
      v-if="step === 1 && link.text && link.text.trim() !== ''"
      class="navigationmain-sousmenu-label">
      {{ link.text }}
    </p>
    <router-link
      v-if="step > 1 && link.routeName"
      :id="'childMenuLeftLayout' + link.routeName"
      :key="link.routeName"
      :to="routeWithParam"
      exact>
      <span v-if="link.iconClasses">
        <span class="is-pulled-left">{{ link.text }}</span>
        <span class="is-padding-right-small is-pulled-right">
          <i :class="link.iconClasses"></i>
        </span>
      </span>
      <span
        v-else
        v-html="link.text"></span>
      <span
        v-if="link.badge === 'options' && runningOptions.length"
        class="dot is-medium is-notification is-margin-left-xsmall">
        <span>{{ runningOptions.length }}</span>
      </span>
      <span
        v-else-if="link.badge === 'wishlists' && wishlists.length"
        class="dot is-medium is-notification is-margin-left-xsmall">{{ wishlists.length }}</span>
      <span
        v-else-if="link.badge === 'denunciation' && runningDenunciations.length"
        class="dot is-medium is-notification is-margin-left-xsmall">{{ runningDenunciations.length }}</span>
    </router-link>
    <div
      v-if="link.children && step === 0"
      @click="toggleMenu(true)"
      class="navigationmain-sousmenu"
      :class="{'hide-menu': toggle && step === 0}">
      <ul class="navigationmain-sousmenu-wrapper">
        <item-left-menu
          :step="step + 1"
          :link="l"
          v-for="(l, i) in link.children"
          :key="i + '-' + l.routeName"></item-left-menu>
      </ul>
    </div>
    <ul
      v-else-if="link.children && step > 0"
      @click="toggleMenu(true)"
      class="navigationmain-sousmenu-list">
      <item-left-menu
        :step="step + 1"
        :link="l"
        v-for="(l, i) in link.children"
        :key="i + '-' + l.routeName"></item-left-menu>
    </ul>
    <a
      @click.prevent.stop="link.method"
      v-else-if="link.method">
      <span>{{ link.text }}</span>
    </a>
  </li>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { isNil } from 'lodash'

export default {
  name: 'ItemLeftMenu',
  components: {
    ItemLeftMenu: () => import('./ItemLeftMenu')
  },
  props: {
    link: {
      type: Object,
      required: true
    },
    step: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      params: {},
      toggle: false,
      subMenuEl: null,
      timer: null
    }
  },
  computed: {
    ...mapState(['currentUser', 'wishlists', 'runningDenunciations']),
    ...mapGetters(['isSuperAdmin', 'runningOptions']),
    /**
      * is profil authorized
      * @param {boolean}
      */
    profilAuthorized () {
      return isNil(this.link.needProfile) || this.link.needProfile.includes(this.currentUser.profil)
    },
    /**
      * is accoun authorized
      * @param {boolean}
      */
    accountAuthorized () {
      return isNil(this.link.needAccount) || this.link.needAccount.includes(this.currentUser.account.account_type)
    },
    /**
      * is accessible
      * @param {boolean}
      */
    isAccessible () {
      if (this.currentUser) {
        return this.isSuperAdmin || (this.profilAuthorized && this.accountAuthorized)
      }
      return false
    },
    /**
      * route and params
      * @param {object}
      */
    routeWithParam () {
      return {
        name: this.link.routeName,
        ...this.params
      }
    },
    /**
      * is current root
      * @param {boolean}
      */
    isActive () {
      return [this.$route.name, this.$route.meta.parentName, this.$route.meta.routeType].includes(this.link.routeName) ||
          [this.$route.name, this.$route.meta.parentName, this.$route.meta.routeType].includes(this.link.routeType)
    }
  },
  created () {
    if (this.link && this.link.params) {
      this.params = this.link.params
    }
  },
  mounted () {
    if (this.step === 0) {
      this.subMenuCalculPos()
      window.addEventListener('resize', this.subMenuCalculPos)
    }
  },
  destroyed () {
    if (this.step === 0) {
      window.removeEventListener('resize', this.subMenuCalculPos)
    }
  },
  methods: {
    /**
      * toogle true or false
      * @param {boolean}
      */
    toggleMenu (val) {
      this.toggle = val
    },
    /**
      * calc margin top
      */
    subMenuCalculPos () {
      if (this.$el && this.$el.querySelector && typeof this.$el.querySelector === 'function') {
        let subMenuEl = this.$el.querySelector(':scope > .navigationmain-sousmenu')
        let wHeight = window.innerHeight
        if (!isNil(subMenuEl)) {
          let subMenuElParent1 = subMenuEl.offsetParent
          let subMenuElParent2 = subMenuElParent1 ? subMenuElParent1.offsetParent : null
          let subMenuElParent3 = subMenuElParent2 ? subMenuElParent2.offsetParent : null
          // Calcul avec le posTop du parent car notre élément est en posAbsolute par rapport à plusieurs parent en posRelatif ou posFixed
          let subMenuPosTop = Math.ceil(
            subMenuEl.offsetTop + subMenuElParent1 ? subMenuElParent1.offsetTop : 0 + subMenuElParent2 ? subMenuElParent2.offsetTop : 0 + subMenuElParent3 ? subMenuElParent3.offsetTop : 0
          )
          let subMenuHeight = subMenuEl.offsetHeight // Hauteur du sous menu
          let totalHeight = Math.ceil(subMenuPosTop + subMenuHeight + 65) // Hauteur total nécessaire pour afficher le sousMenu par rapport à sa position
          let marginTop = (totalHeight > wHeight) ? Math.ceil(wHeight - totalHeight) - 38 + 'px' : 0 // Calcul du marginTop négatif pour faire remonter le menu
          subMenuEl.style.marginTop = marginTop // Application du margin top
        }
      }
    }
  }
}
</script>
